/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { ReactChildren, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';

export interface IContainerProps {
  children?: ReactChildren;
  backgroundImage?: string;
}

export const PageContainer = ({
  children,
  backgroundImage,
}: ISignUpPageProps) => {
  return (
    <main>
      <section className="mt-5 mt-lg-0 m-sm-5 bg-soft d-flex align-items-center justify-content-center">
        <Row
          className="justify-content-center form-bg-image mt-2"
          // style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          {children}
        </Row>
      </section>
    </main>
  );
};

PageContainer.defaultProps = {
  // backgroundImage: SIGN_IN_ILLUSTRATION,
};
